import { render, staticRenderFns } from "./VideoFormContent.vue?vue&type=template&id=23fef6c8"
import script from "./VideoFormContent.vue?vue&type=script&lang=js"
export * from "./VideoFormContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports